<script lang="ts" setup>
const { t, locale, setLocale } = useI18n()
const localePath = useLocalePath()
const { user, clear } = useUserSession()

// Redmine user logic
const userRedmine = ref(null)

async function fetchUserRedmine() {
  userRedmine.value = await $fetch(`/api/users/${user.value.redmineUserId}`)
}

// Dropdown menu items
const items = computed(() => [
  [
    {
      slot: 'email',
      class: 'cursor-text select-text bg-white hover:bg-white opacity-100',
      disabled: true,
    },
  ],
  [
    {
      icon: 'meteor-icons:language',
      slot: 'language',
      class: 'cursor-default bg-white hover:bg-white',
    },
  ],
  [
    {
      label: t('horizontalMenu.changePassword'),
      icon: 'mdi:key-change',
      click: () => {
        navigateTo(localePath({ name: 'changePassword' }))
      },
    },
  ],
  [
    {
      label: t('horizontalMenu.signOut'),
      icon: 'si:sign-out-alt-fill',
      click: clear,
    },
  ],
])

// Language logic
const language = ref('')

watch(locale, async () => {
  language.value = locale.value
})

onMounted(async () => {
  language.value = locale.value
  await fetchUserRedmine()
})
</script>

<template>
  <div>
    <UDropdown v-if="user" :items="items" :ui="{ width: 'w-auto' }">
      <UButton color="gray" trailing-icon="i-heroicons-chevron-down-20-solid">
        <UAvatar
          v-if="
            userRedmine &&
            userRedmine.user &&
            userRedmine.user.avatar_url &&
            userRedmine.user.avatar_url !== null &&
            userRedmine.user.avatar_url !== ''
          "
          :src="userRedmine?.user?.avatar_url"
          :alt="`${userRedmine?.user?.firstname} ${userRedmine?.user?.lastname}`"
          size="2xs"
        ></UAvatar>
        {{ `${userRedmine?.user?.firstname} ${userRedmine?.user?.lastname}` }}
      </UButton>
      <template #email>
        <!-- Handling of signed in  user -->
        <div class="flex items-center gap-3">
          <div class="text-left opacity-70">
            <p>{{ t('horizontalMenu.signedInAs') }}</p>
            <p class="truncate font-semibold text-gray-900">
              {{ user.email }}
            </p>
          </div>
          <div>
            <UAvatar
              v-if="
                userRedmine &&
                userRedmine.user &&
                userRedmine.user.avatar_url &&
                userRedmine.user.avatar_url !== null &&
                userRedmine.user.avatar_url !== ''
              "
              :src="userRedmine?.user?.avatar_url"
              :alt="`${userRedmine?.user?.firstname} ${userRedmine?.user?.lastname}`"
              size="md"
            ></UAvatar>
          </div>
        </div>
      </template>
      <!-- Language handling -->
      <template #language="{ item }">
        <UButton
          color="gray"
          size="xs"
          :class="language.startsWith('cs') ? 'bg-gray-300' : ''"
          class="font-semibold hover:bg-gray-300"
          @click="setLocale('cs')"
        >
          CS
        </UButton>
        <UButton
          color="gray"
          size="xs"
          :class="language.startsWith('en') ? 'bg-gray-300' : ''"
          class="font-semibold hover:bg-gray-300"
          @click="setLocale('en')"
        >
          EN
        </UButton>
        <UIcon
          :name="item.icon"
          class="ms-auto h-5 w-5 flex-shrink-0 text-gray-400"
        />
      </template>
      <!-- Classic buttons -->
      <template #item="{ item }">
        <span class="truncate">{{ item.label }}</span>
        <UIcon
          :name="item.icon"
          class="ms-auto h-5 w-5 flex-shrink-0 text-gray-400"
        />
      </template>
    </UDropdown>
  </div>
</template>
